export default __webpack_public_path__ + "f1d7e2fe8bd095ba3a3828b6c2324148.ico";